/**
 * Ensure external bookmaker URLs are safe before rendering anchor tags.
 */
export function getSafeExternalUrl(rawUrl?: string | null): string | null {
  if (!rawUrl) {
    return null;
  }

  try {
    const parsed = new URL(rawUrl, window.location.origin);

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }

    return parsed.href;
  } catch (error) {
    console.error('Invalid external URL provided:', error);
    return null;
  }
}
